import { createContext } from 'react';
import _ from 'lodash';

const UserContext = createContext({
  authDrawerOpen: false,
  setAuthDrawerOpen: () => {},
  seagullUser: {},
  setSeagullUser: () => {},
  notifications: {},
  setNotifications: () => {},
  userLocation: [],
  globalSearch: '',
  setGlobalSearch: () => {},
  searchActive: false,
  setSearchActive: () => {},
  unitPreferences: [],
  unitPreferencesAction: () => {},
});

// Some stored user records have unit_preferences saved as a plain object
// (e.g. { "0": { name, value }, ..., map_default_view: "..." }) rather than
// an array, left over from a legacy preferences shape. Normalize to an array
// of { name, value, pinned } entries so downstream code can rely on array methods.
const toUnitPreferencesArray = (unitPreferences) => {
  if (!unitPreferences || Object.keys(unitPreferences).length === 0) {
    return [];
  }
  if (Array.isArray(unitPreferences)) {
    return unitPreferences;
  }
  return Object.values(unitPreferences).filter((entry) => entry && typeof entry === 'object' && 'name' in entry);
};

const unitPrefsReducer = (state, action) => {
  switch (action.type) {
    case 'UNIT':
      if (_.isEmpty(state)) {
        return ([{
          name: action.unit,
          value: action.value,
          pinned: action.pinned,
        }]);
      }
      if (state.find((unit) => unit.name === action.unit)) {
        return state.map((unit) => {
          if (unit.name === action.unit) {
            const value = Object.hasOwn(action, 'value') ? action.value : unit.value;
            const pinned = Object.hasOwn(action, 'pinned') ? action.pinned : unit.pinned;
            return {
              ...unit,
              value,
              pinned,
            };
          }
          return unit;
        });
      }
      return state.concat({ name: action.unit, value: action.value, pinned: action.pinned });
    case 'REPLACE':
      return toUnitPreferencesArray(action.value);
    default:
      return state;
  }
};

const pinnedParams = (unitPreferences) => {
  const pinned = [];
  toUnitPreferencesArray(unitPreferences).forEach((param) => {
    if (param.pinned) {
      pinned.push(param.name);
    }
  });
  return pinned;
};

export default UserContext;
export { pinnedParams, unitPrefsReducer };
